import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdArrowBack,
  MdArrowBackIos,
  MdArrowBackIosNew,
  MdArrowForward,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdCloud,
  MdFolder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdSend,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Operator.css";
import Spinner from "../components/Spinner";
import { useNavigate, useParams } from "react-router";
import { isEmpty } from "../functions/isEmpty";

export default function Operator({
  apiURL,
  isMobile,
  chats,
  scrollPositionHome,
  setScrollPositionHome,
  operators,
  user,
  searchString,
  setSearchString,
  setActiveOperator,
  activeOperator,
  documents,
  messages,
  setMessages,
  tasks,
  setTasks,
}) {
  const [showTasks, setShowTasks] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();
  const { id } = useParams();

  const skills = ["Alle", "Automatisierung", "Kunden"];

  return (
    <div className="operator">
      <div className="operator_topnav">
        <div className="operator_topnav_left">
          <div className="operator_topnav_backbtn" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </div>
          <div className="operator_topnav_thumbnail">
            <img
              src={activeOperator?.img_url}
              className="operator_topnav_thumbnail_img"
            />
            {activeOperator?.name}
          </div>
        </div>
      </div>
      <div className="operator_body">
        {skills.map((skill, index) => (
          <div className="operator_body_element">
            <div className="operator_body_element_left">{skill}</div>
            <div className="operator_body_element_right">
              <ArrowForwardIcon />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const SendIcon = styled(MdSend)`
  font-size: 25px;
  color: #ffffff;
`;

const ArrowBackIcon = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #717171;
`;

const ArrowForwardIcon = styled(MdArrowForward)`
  font-size: 15x;
  color: #717171;
`;

const CloudIcon = styled(MdFolder)`
  font-size: 18px;
  color: #474747;
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 25px;
  color: #0072f5;
`;

const AddIcon = styled(MdAdd)`
  font-size: 25px;
  color: #717171;
`;

const FolderIcon = styled(MdFolder)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const AccountIcon = styled(MdPerson)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;
